export default "__VITE_ASSET__BhBJOq0d__"